// src/v3/interactions/more.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var MoreIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "MoreIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M14.493 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM4.85 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm14.286 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
  }
) });

export {
  MoreIcon
};
